import React from "react";

export default function Section14() {
  return (
    <div className="w-full ShopifyIntro">
      <div className="md:w-[80%] w-[90%] text-center mx-auto py-5 md:py-[40px]">
        <h2 className="text-[28px] md:text-[36px] font-bold leading-[42px] mb-4">
          Let’s Build a Shopify Store That Converts
        </h2>
        <p className="text-[#373737] text-sm md:text-base leading-[26px] mb-6">
          From ambitious startups to scaling brands, we help businesses like yours build Shopify stores that are both beautiful and built to perform. Our work is grounded in strategy, design, and development excellence, and we’re ready to help you take your next big step.
        </p>
        <p className="text-[red] text-sm md:text-base leading-[26px] font-medium">
          Get in touch with our team today to explore how we can bring your Shopify vision to life.
        </p>
      </div>
      <div className="text-center btn-container">
        <a
          href="https://mean3.com/contact-mean3/"
          className="inline-flex cursor-pointer items-center bg-[#DA2128] font-bold rounded-[3px] py-[10px] px-[15px] border-none text-white"
        >
          Discuss Project With Mean3
          <svg
            className="ml-[15px]"
            viewBox="0 0 1024 1024"
            fill="currentColor"
            height="16px"
            width="16px"
          >
            <path d="M869 487.8L491.2 159.9c-2.9-2.5-6.6-3.9-10.5-3.9h-88.5c-7.4 0-10.8 9.2-5.2 14l350.2 304H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h585.1L386.9 854c-5.6 4.9-2.2 14 5.2 14h91.5c1.9 0 3.8-.7 5.2-2L869 536.2a32.07 32.07 0 000-48.4z" />
          </svg>
        </a>
      </div>
    </div>
  );
}
